import * as Catalog from './catalog';
import * as Checkout from './checkout';
import * as User from './user';

export const Repositories = {
  User,
  Catalog,
  Checkout,
};
